var render = function render(){var _vm=this,_c=_vm._self._c;return _c('window-content',[_c('user-form',{attrs:{"user-id":_vm.id,"edit-username":"","role":_vm.role,"full":_vm.tiposForFull,"personId":_vm.personId},on:{"updateUser":_vm.updateUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }